export const integrations = {
  seo: {
    title: 'Integrationen – verbinde deine Lieblingsapps | Bistroo',
    description: 'Verbinde Lightspeed, Mollie, Exact und mehr mit einem Klick mit Bistroo. Alle verfügbaren Integrationen für dein Restaurant ansehen.',
  },
  hero: {
    heading: {
      1: 'Deine',
      2: 'Lieblingsapps',
      3: 'mit einem Klick integriert',
    },
    description: {
      1: 'Wir bieten eine breite Palette an Integrationen, damit du dich auf das konzentrieren kannst, was du gut kannst, ohne Aufwand.',
      2: 'Unsere Integrationen sorgen dafür, dass alles mühelos zusammenarbeitet, damit du dich auf das Wachstum deines Unternehmens konzentrieren kannst – nicht auf die Verwaltung von Technologie. Schnelle Installation, reibungslose Erfahrung und kein Aufwand.',
    },
  },
  cards: {
    card_1: {
      title: 'Wähle deine Integration',
      text: 'Wähle deine Integration aus unserem App-Marktplatz im Bistroo Manager.',
      button: 'App-Marktplatz ansehen',
      img_alt: '',
    },
    card_2: {
      title: 'Folge der Anleitung',
      text: 'Wir geben dir die Schritte, die du für einen reibungslosen Integrationsprozess befolgen musst.',
      button: '',
      img_alt: '',
    },
    card_3: {
      title: 'Aktiviere die Integration',
      text: 'Aktiviere die Integration in der Bistroo-Verwaltungs-App und beginne mit dem Datenaustausch.',
      button: '',
      img_alt: '',
    },
    card_4: {
      title: 'Fragen?',
      text: 'Hast du Fragen oder möchtest du, dass jemand einen Blick auf deine Integration wirft? Zögere nicht, uns zu kontaktieren.',
      button: '',
      img_alt: '',
    },
    card_5: {
      title: 'Du bist bereit loszulegen!',
      text: 'Nach Abschluss dieser Schritte ist deine Software vollständig integriert.',
      button: '',
      img_alt: '',
    },
  },
  partner: {
    title: 'Auch Partner werden?',
    text: {
      1: 'Melde dich bald über unser Partner-Portal an. Bis dahin nimm',
      2: 'Kontakt mit uns',
      3: 'auf.',
    },
  },
}
